import React from "react";
import {
  BrowserRouter as Router,
  Route,
  Link,
  withRouter
} from "react-router-dom";
import parse from "html-react-parser";
import axios from "axios";
import Config from "../config/config";
import loader from "../img/loader.gif";
import closeSvg from "../img/close.svg";
import warningImg from "../img/warning.png";
import { confirmAlert } from "react-confirm-alert";
import "react-confirm-alert/src/react-confirm-alert.css";

const { API_URL } = Config;

class QuestionList extends React.Component {
  state = {
    questionList: [],
    loading: false,
    title: "Help Topics",
    showToast: false,
    message: ""
  };
  componentDidMount() {
    console.log("componentDidMount", this.props);
    let that = this;
    const { searchValue } = this.props;
    const { id } = this.props.match.params;
    if (searchValue !== "") {
      that.handleAppSearch(searchValue);
    } else {
      if (id) {
        console.log("QuestionListTokenId : ", id);
        that.getNextQuestion(id);
      }
    }
  }

  componentWillReceiveProps(props) {
    let that = this;
    console.log("componentWillReceiveProps", props);
    const { id } = props.match.params;
    if (id.indexOf("ANS") !== -1) {
      this.getAnswer(id);
    } else if (id) {
      console.log("QuestionListTokenId : ", id);
      that.getNextQuestion(id);
    }
  }

  showToast = (status, message) => {
    console.log(`showToast : ${status} ${message}`);
    this.setState({ showToast: status, message: message });
    setTimeout(() => {
      this.setState({ showToast: false, message: "" });
    }, 5000);
  };

  closeToast = () => {
    this.setState({ showToast: false, message: "" });
  };

  getNextQuestion = tokenId => {
    console.log("getNextQuestionCalled");
    var that = this;
    that.setState({
      loading: true
    });
    axios
      .post(API_URL, {
        action: "sheets.getForToken", //api call
        data: {
          token: tokenId
        }
      })
      .then(function(response) {
        console.log("getQuestionListResponse", response);
        if (response.status === 200) {
          that.setState({
            loading: false
          });
          if (response.data.status) {
            let list = response.data.data.list ? response.data.data.list : [];
            that.setState({
              questionList: list,
              title: response.data.data.title
            });
          } else {
            that.showToast(true, response.data.errMsg);
          }
        } else if (response.status === 500 || 503 || 502 || 504) {
          that.showToast(true, "Something went wrong, please try again later");
          that.setState({
            loading: false,
            questionList: [],
            title: ""
          });
        }
      })
      .catch(function(error) {
        console.log(error);
        that.setState({
          loading: false
        });
        that.showToast(
          true,
          "Hey! Your internet connection might be slow. Please check and try again."
        );
      });
  };

  handleAppSearch = value => {
    const that = this;
    that.setState({
      loading: true
    });
    if (value) {
      axios
        .post(API_URL, {
          action: "sheets.getSearchQuestion", //api call
          data: {
            searchK: value
          }
        })
        .then(function(response) {
          console.log("handleAppSearchResponse", response);
          that.setState({
            loading: false
          });
          if (response.status === 200) {
            if (response.data.status) {
              let data = response.data.data ? response.data.data : [];
              that.setState({
                questionList: data
              });
            } else {
              that.showToast(true, response.data.errMsg);
            }
          } else if (response.status === 500 || 503 || 502 || 504) {
            that.showToast(
              true,
              "Something went wrong, please try again later"
            );
          }
        })
        .catch(function(error) {
          that.setState({
            loading: false
          });
          console.log(error);
          that.showToast(
            true,
            "Hey! Your internet connection might be slow. Please check and try again"
          );
        });
    } else {
      that.showToast(true, "Searach is required field");
    }
  };

  getAnswer = recivedToken => {
    this.setState({
      loading: true
    });
    var that = this;
    axios
      .post(API_URL, {
        action: "sheets.getAnsByToken", //api call
        data: {
          ansToken: recivedToken
        }
      })
      .then(function(response) {
        console.log("response", response);
        if (response.status === 200) {
          if (response.data.status) {
            var qL = response.data.data;
            that.setState({
              loading: false,
              questionList: qL
            });
          } else {
            that.showToast(true, response.data.errMsg);
          }
        } else if (response.status === 500 || 503 || 502 || 504) {
          that.showToast(true, "Something went wrong, please try again later");
        }
      })
      .catch(function(error) {
        console.log(error);
        that.showToast(
          true,
          "Hey! Your internet connection might be slow. Please check and try again."
        );
      });
  };

  getLink = e => {
    var that = this;
    // var clickedLink = e.target.outerText;
    var linkName = e.target.outerText; // linkName
    var linkUrl = e.target.href; // url

    // var link = linkName + "(" + linkUrl +")";
    var getURI = e.target.baseURI; // http://localhost:3000/help/ANS_001
    if (getURI.indexOf("ANS")) {
      var ansToken = getURI.split("/help/")[1];
      console.log("Token : ", ansToken);
      axios
        .post(API_URL, {
          action: "sheets.storeLinksOfAns", //api call
          data: {
            ansToken: ansToken,
            linkName: linkName,
            linkUrl: linkUrl
          }
        })
        .then(function(response) {
          console.log("response", response);
          if (response.status === 200) {
            if (response.data.status) {
            } else {
              that.showToast(true, response.data.errMsg);
            }
          } else if (response.status === 500 || 503 || 502 || 504) {
            that.showToast(
              true,
              "Something went wrong, please try again later"
            );
          }
        })
        .catch(function(error) {
          console.log(error);
          that.showToast(
            true,
            "Hey! Your internet connection might be slow. Please check and try again."
          );
        });
    } else alert("error");
  };

  submit = () => {
    confirmAlert({
      title: "Thank you for your feedback",
      // message: 'Are you sure to do this.',
      buttons: [
        {
          label: "Close"
          //onClick: () => alert('Click Yes')
        }
        // {
        //   label: 'No',
        //   onClick: () => alert('Click No')
        // }
      ]
    });
  };

  getLinkList = linkTxt => {
    var linkListArr = linkTxt.split(",");
    var linkCmp = [];
    for (let i = 0; i < linkListArr.length; i++) {
      const element = linkListArr[i];
      if (element.split("=").length > 1) {
        var aText = element.split("=")[0];
        var aLink = element.split("=")[1];
        linkCmp.push(
          <div className="useful-link">
            <a
              onClick={this.getLink}
              target="_blank"
              style={{ display: "block" }}
              key={i}
              href={aLink}
            >
              {aText}
            </a>
          </div>
        );
      }
    }
    return linkCmp;
  };

  getQuestionList = () => {
    var qListArr = [];
    var questionList = this.state.questionList;
    const params = new URLSearchParams(window.location.search);
    const source = params.get("src");
    const sourceType = params.get("type");
    for (let i = 0; i < questionList.length; i++) {
      const aQuestion = questionList[i];
      if (aQuestion.Token.indexOf("ANS") !== -1) {
        // Answer
        if (aQuestion.Answer) {
          qListArr.push(
            <div className="aAnsDiv" key={i}>
              <div className="ans-q">{aQuestion.Short_Question}</div>
              <div className="ans-content">{parse(aQuestion.Answer)}</div>
              <div className="feedback-container">
                <p>Was this answer helpful? </p>
                <a href="#" onClick={this.submit}>
                  Yes
                </a>
                <a href="#" onClick={this.submit}>
                  No
                </a>

                {/* <button className="helpBtn" onClick={this.submit}>Confirm dialog</button> */}
              </div>
              <div className="ans-usefulLinks">
                <p style={{ fontSize: "larger" }}>Useful links: </p>
                {this.getLinkList(aQuestion.Extra_URLs)}
              </div>
              {sourceType !== "ltd" ? (
                <div className="ans-help">
                  Still Need Help?
                  <button className="helpBtn">
                    {aQuestion["CAT Text"] ? (
                      aQuestion["CAT Text"]
                    ) : (
                      <a
                        href="https://www.earlysalary.com/contact-us/#jubee"
                        target="_blank"
                      >
                        Contact Us
                      </a>
                    )}
                  </button>
                </div>
              ) : null}
              <Link
                className="clear-a-style"
                to={
                  source === "web"
                    ? sourceType !== "ltd"
                      ? "/help/" + aQuestion.Token + `?src=web`
                      : "/help/" + aQuestion.Token + `?src=web&type=ltd`
                    : "/help/" + aQuestion.Token
                }
              ></Link>
            </div>
          );
        } else {
          if (aQuestion.Token !== null) {
            qListArr.push(
              <div className="aQuestionDiv" key={i}>
                {" "}
                <Link
                  className="clear-a-style"
                  to={
                    source === "web"
                      ? sourceType !== "ltd"
                        ? "/help/" + aQuestion.Token + `?src=web`
                        : "/help/" + aQuestion.Token + `?src=web&type=ltd`
                      : "/help/" + aQuestion.Token
                  }
                >
                  {aQuestion.Short_Question}
                </Link>
                <Link
                  className="clear-a-style"
                  to={
                    source === "web"
                      ? sourceType !== "ltd"
                        ? "/help/" + aQuestion.Token + `?src=web`
                        : "/help/" + aQuestion.Token + `?src=web&type=ltd`
                      : "/help/" + aQuestion.Token
                  }
                >
                  <img
                    style={{ height: "10px" }}
                    alt=""
                    src="data:image/svg+xml;base64,
                  PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHhtbG5zOnhsaW5rPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5L3hsaW5rIiB2ZXJzaW9uPSIxLjEiIGlkPSJDYXBhXzEiIHg9IjBweCIgeT0iMHB4IiB3aWR0aD0iNTEyIiBoZWlnaHQ9IjUxMiIgdmlld0JveD0iMCAwIDQ1MS44NDYgNDUxLjg0NyIgc3R5bGU9ImVuYWJsZS1iYWNrZ3JvdW5kOm5ldyAwIDAgNDUxLjg0NiA0NTEuODQ3OyIgeG1sOnNwYWNlPSJwcmVzZXJ2ZSI+PGc+PGc+Cgk8cGF0aCBkPSJNMzQ1LjQ0MSwyNDguMjkyTDE1MS4xNTQsNDQyLjU3M2MtMTIuMzU5LDEyLjM2NS0zMi4zOTcsMTIuMzY1LTQ0Ljc1LDBjLTEyLjM1NC0xMi4zNTQtMTIuMzU0LTMyLjM5MSwwLTQ0Ljc0NCAgIEwyNzguMzE4LDIyNS45MkwxMDYuNDA5LDU0LjAxN2MtMTIuMzU0LTEyLjM1OS0xMi4zNTQtMzIuMzk0LDAtNDQuNzQ4YzEyLjM1NC0xMi4zNTksMzIuMzkxLTEyLjM1OSw0NC43NSwwbDE5NC4yODcsMTk0LjI4NCAgIGM2LjE3Nyw2LjE4LDkuMjYyLDE0LjI3MSw5LjI2MiwyMi4zNjZDMzU0LjcwOCwyMzQuMDE4LDM1MS42MTcsMjQyLjExNSwzNDUuNDQxLDI0OC4yOTJ6IiBkYXRhLW9yaWdpbmFsPSIjMDAwMDAwIiBjbGFzcz0iYWN0aXZlLXBhdGgiIGRhdGEtb2xkX2NvbG9yPSIjMDAwMDAwIiBzdHlsZT0iZmlsbDojNUM1QzVDIj48L3BhdGg+CjwvZz48L2c+IDwvc3ZnPg=="
                  />
                </Link>{" "}
              </div>
            );
          } else {
            qListArr.push(
              <div className="aQuestionDiv" key={i}>
                {" No Quesatsdkjh"}
                <Link
                  className="clear-a-style"
                  to={
                    source === "web"
                      ? sourceType !== "ltd"
                        ? "/help/" + aQuestion.Token + `?src=web`
                        : "/help/" + aQuestion.Token + `?src=web&type=ltd`
                      : "/help/" + aQuestion.Token
                  }
                >
                  {"KDFBHSDJHNDSFJHG"}
                </Link>{" "}
              </div>
            );
          }
        } // inner else
      } else {
        qListArr.push(
          <Link
            className="clear-a-style"
            to={
              source === "web"
                ? sourceType !== "ltd"
                  ? "/help/" + aQuestion.Token + `?src=web`
                  : "/help/" + aQuestion.Token + `?src=web&type=ltd`
                : "/help/" + aQuestion.Token
            }
          >
            <div className="aQuestionDiv" key={i}>
              {" "}
              {aQuestion.Question}{" "}
              <img
                style={{ height: "10px" }}
                alt=""
                src="data:image/svg+xml;base64,
            PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHhtbG5zOnhsaW5rPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5L3hsaW5rIiB2ZXJzaW9uPSIxLjEiIGlkPSJDYXBhXzEiIHg9IjBweCIgeT0iMHB4IiB3aWR0aD0iNTEyIiBoZWlnaHQ9IjUxMiIgdmlld0JveD0iMCAwIDQ1MS44NDYgNDUxLjg0NyIgc3R5bGU9ImVuYWJsZS1iYWNrZ3JvdW5kOm5ldyAwIDAgNDUxLjg0NiA0NTEuODQ3OyIgeG1sOnNwYWNlPSJwcmVzZXJ2ZSI+PGc+PGc+Cgk8cGF0aCBkPSJNMzQ1LjQ0MSwyNDguMjkyTDE1MS4xNTQsNDQyLjU3M2MtMTIuMzU5LDEyLjM2NS0zMi4zOTcsMTIuMzY1LTQ0Ljc1LDBjLTEyLjM1NC0xMi4zNTQtMTIuMzU0LTMyLjM5MSwwLTQ0Ljc0NCAgIEwyNzguMzE4LDIyNS45MkwxMDYuNDA5LDU0LjAxN2MtMTIuMzU0LTEyLjM1OS0xMi4zNTQtMzIuMzk0LDAtNDQuNzQ4YzEyLjM1NC0xMi4zNTksMzIuMzkxLTEyLjM1OSw0NC43NSwwbDE5NC4yODcsMTk0LjI4NCAgIGM2LjE3Nyw2LjE4LDkuMjYyLDE0LjI3MSw5LjI2MiwyMi4zNjZDMzU0LjcwOCwyMzQuMDE4LDM1MS42MTcsMjQyLjExNSwzNDUuNDQxLDI0OC4yOTJ6IiBkYXRhLW9yaWdpbmFsPSIjMDAwMDAwIiBjbGFzcz0iYWN0aXZlLXBhdGgiIGRhdGEtb2xkX2NvbG9yPSIjMDAwMDAwIiBzdHlsZT0iZmlsbDojNUM1QzVDIj48L3BhdGg+CjwvZz48L2c+IDwvc3ZnPg=="
              />
            </div>
          </Link>
        );
      }
    }
    return qListArr;
  };

  render() {
    console.log(
      "window.location.pathname == window.orignalURL",
      window.location.pathname,
      window.orignalURL
    );
    // console.log("QuestionListProps : ", this.props.match.params.id);
    const { title, showToast, message, questionList } = this.state;
    console.log("questionList", questionList);

    questionList.sort(function(a, b) {
      return (a.Token > b.Token) - (a.Token < b.Token);
    });

    return (
      <div className="app">
        <div className="app-body">
          <div className="container-width-aware">
            <div className="card-shadow q-container">
              <div className="q-list">
                <div className="clear-a-style page-title">{title}</div>

                {this.state.loading ? (
                  <div className="loading-svg">
                    <strong className="loader-heading">Please Wait...</strong>
                    <img src={loader} className="loader-img" />
                  </div>
                ) : (
                  <div>
                    {questionList.length > 0 ? (
                      this.getQuestionList()
                    ) : (
                      <div className="warning-container">
                        <img className="warning-img" src={warningImg} />
                        <p>Data Not Found</p>
                      </div>
                    )}
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
        <div className="app-footer">
          {showToast ? (
            <div className="show-toast-message">
              <p>{message}</p>
              <img
                className="close-toast"
                src={closeSvg}
                onClick={this.closeToast}
              ></img>
            </div>
          ) : null}
        </div>
      </div>
    );
  }
}
export default withRouter(QuestionList);
